module.exports = __webpack_public_path__ + "media/swoosh.ac2c8b8f.mp3";